export default __webpack_public_path__ + "static/media/ic_netherlands.1378a6f0.svg";